<template>
  <div>
    <div class="main">
      <div class="top">{{ bulletinTitle }}</div>
      <div v-if="examRegisterObj.list.length > 0" class="center">
        <div class="affiche" v-for="item in examRegisterObj.list" :key="item.id">
          <div class="title">{{ item.title }}</div>
          <div class="content">{{ item.content }}</div>
          <div class="time">
            {{ item.examModel.applyStartTime | parseTime }} -- {{ item.examModel.applyEndTime | parseTime }}
          </div>
        </div>
      </div>
      <el-empty v-else class="enpty" :description="'暂无' + this.bulletinTitle"></el-empty>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { parseTime } from '@/utils/time'
export default {
  data() {
    return {
      listQuery: {
        pageNum: 1,
        pageSize: 8,
        status: ''
      },
      bulletinTitle: '报名时间公告'
    }
  },
  filters: {
    parseTime(val) {
      return parseTime(val, '{y}-{m}-{d} {h}:{i}') || '--'
    }
  },
  mounted() {
    this.listQuery.type = this.$route.query.bulletinType
    if (this.$route.query.bulletinType === 'register') {
      this.bulletinTitle = '报名时间公告'
    }
    if (this.$route.query.bulletinType === 'admissionTicket') {
      this.bulletinTitle = '打印准考证公告'
    }
    if (this.$route.query.bulletinType === 'grade') {
      this.bulletinTitle = '成绩查询公告'
    }
    this.getBulletinDetails()
  },

  computed: {
    ...mapState({
      examRegisterObj: state => state.examInfo.examRegisterObj,
      examAdmissionTicketObj: state => state.examInfo.examAdmissionTicketObj,
      examGradeObj: state => state.examInfo.examGradeObj
    })
  },

  methods: {
    getBulletinDetails() {
      const params = {
        pageNum: this.listQuery.pageNum,
        pageSize: this.listQuery.pageSize,
        params: {
          type: this.listQuery.type
        }
      }
      if (this.listQuery.type === 'register') {
        params.params.type = 'Registration_Time_Announcement'
        this.$store.dispatch('getExamRegisterObj', params).then(res => {
          console.log(this.examRegisterObj)
        })
      }
      if (this.listQuery.type === 'admissionTicket') {
        params.params.type = 'Notice_of_Examination_Time'
        this.$store.dispatch('getExamAdmissionTicketrObj', params)
      }
      if (this.listQuery.type === 'grade') {
        params.params.type = 'Examination_Announcement'
        this.$store.dispatch('getExamGradeObj', params)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@media screen and (min-width: 320px) and (max-width: 768px) {
  @import '../styles/examInfo.mobile';
}
@media screen and (min-width: 769px) {
  @import '../styles/examInfo.pc';
}
</style>
